// ==============================|| SPEECH-TO-TEXT ADAPTER INTERFACE ||============================== //
//
// Adapter Pattern: Define a common interface for speech-to-text providers.
// To add a new provider (e.g., Azure), create a new class that extends SpeechAdapter
// and implement all methods. Then register it in SpeechAdapterFactory.
//

/**
 * Base class / interface for speech-to-text adapters.
 * All providers must implement these methods.
 */
export class SpeechAdapter {
  /**
   * Check if this speech provider is available in the current environment.
   * @returns {boolean}
   */
  isSupported() {
    throw new Error('isSupported() must be implemented');
  }

  /**
   * Start listening for speech input.
   * @param {object} options
   * @param {string} options.lang - BCP-47 language code (e.g., 'kn-IN')
   * @param {boolean} options.continuous - Keep listening after pauses
   * @param {boolean} options.interimResults - Provide partial results
   * @param {function} options.onResult - Called with { transcript, isFinal }
   * @param {function} options.onError - Called with error object
   * @param {function} options.onEnd - Called when recognition ends
   * @param {function} options.onStart - Called when recognition starts
   */
  start(options) {
    throw new Error('start() must be implemented');
  }

  /**
   * Stop listening.
   */
  stop() {
    throw new Error('stop() must be implemented');
  }

  /**
   * Abort listening immediately (discard pending results).
   */
  abort() {
    throw new Error('abort() must be implemented');
  }
}

export default SpeechAdapter;
